module.exports = __webpack_public_path__ + "img/hong.8f99402a.png";